import { createContext, useContext } from 'react';

type Context = {
  fit: 'content' | 'parent';
};

export const OrderedStepsContext = createContext<Context | null>(null);

export function useOrderedStepContext() {
  const context = useContext(OrderedStepsContext);

  if (context === null) {
    throw new Error(
      'useOrderedStepContext should be within an OrderedStepsContext',
    );
  }

  return {
    fit: context.fit,
  };
}
